import { render, staticRenderFns } from "./SubTaskDetailsView.vue?vue&type=template&id=70cc047c&"
import script from "./SubTaskDetailsView.vue?vue&type=script&lang=js&"
export * from "./SubTaskDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./SubTaskDetailsView.vue?vue&type=style&index=0&id=70cc047c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports